import AllocatorDetailsModal from './AllocatorDetailsModal'

export default AllocatorDetailsModal
